export default __webpack_public_path__ + "static/media/list-checkbox.de0982d9.svg";